import { call, takeEvery, put, select } from 'redux-saga/effects';
import { getInstance } from 'util/i18n';
import { SetLanguageRequestAction, SetLanguageSuccessAction } from 'actions/shellActions';
import * as Moment from 'moment';
import { measureTimelineLabelWidth } from 'startup/measureTimelineLabelWidth';
import { setTimelineLabelWidth } from 'actions/monitoringActions';
import { getAvailableLanguages } from 'selectors/serverSelectors';
import { Language } from 'types';

// Require each of the languages here to ensure they get bundled in the app
require('moment/locale/ar');
require('moment/locale/de');
require('moment/locale/es');
require('moment/locale/fr');
require('moment/locale/he');
require('moment/locale/ja');
require('moment/locale/ko');
require('moment/locale/pl');
require('moment/locale/pt');
require('moment/locale/ru');
require('moment/locale/sv');
require('moment/locale/tr');
require('moment/locale/zh-cn'); // Simplified
require('moment/locale/zh-tw'); // Traditional

// List of the above bundled langauges (plus english)
export const bundledLanguages: string[] = [
    'en',
    'ar',
    'de',
    'es',
    'fr',
    'he',
    'ja',
    'ko',
    'pl',
    'pt',
    'ru',
    'sv',
    'tr',
    'zh-CHS',
    'zh-CHT',
];

export function* setLanguageWatcher() {
    yield takeEvery('SET_LANGUAGE_REQUEST', setLanguageSaga);
}

export function* setLanguageSaga(action: SetLanguageRequestAction) {
    let languageCode = action.payload;
    const i18n = yield call(getInstance);
    const languages: ReadonlyArray<Language> | null = yield select(getAvailableLanguages);
    if (languages) {
        const language = languages.filter(l => l.code === languageCode).shift();
        if (!language) {
            const [ , twoLetterCode = 'en' ] = /^(..)-.+$/.exec(languageCode) || [];
            languageCode = twoLetterCode;
        }
    }
    yield call([ i18n, 'changeLanguage' ], languageCode);
}


export function* setLanguageSuccessWatcher() {
    yield takeEvery('SET_LANGUAGE_SUCCESS', setLanguageSuccessSaga, window.localStorage);
}

export function* setLanguageSuccessSaga(storage: Storage, action: SetLanguageSuccessAction) {
    let languageCode = action.payload;
    yield call([ storage, 'setItem' ], 'lang', languageCode);
    
    if (languageCode.toLowerCase() === 'zh-chs') languageCode = 'zh-cn';
    if (languageCode.toLowerCase() === 'zh-cht') languageCode = 'zh-tw';
    yield call([ console, 'log' ], `Setting moment locale to ${languageCode}`);
    yield call(Moment.locale, languageCode);

    // Measure how wide to make the time labels on the timelines
    const width = yield call(measureTimelineLabelWidth);
    yield put(setTimelineLabelWidth(width));
}



// WEBPACK FOOTER //
// ./src/sagas/shell/setLanguageSaga.ts